import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "modal-content"
}
const _hoisted_2 = ["placeholder"]
const _hoisted_3 = {
  key: 3,
  class: "flex"
}
const _hoisted_4 = { class: "width-50pct" }
const _hoisted_5 = { class: "margin-sites-dispo" }
const _hoisted_6 = { class: "input-container-with-icon" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = { class: "sites-list-container" }
const _hoisted_10 = { class: "bar-verticale width-50pct" }
const _hoisted_11 = { class: "margin-left-3pct" }
const _hoisted_12 = { class: "margin-top-3pct" }
const _hoisted_13 = { class: "font-size-15px color-grey" }
const _hoisted_14 = {
  key: 0,
  class: "font-size-15px color-grey margin-top-10px"
}
const _hoisted_15 = { class: "flex wrap sites-list-container recap-sites-list-container" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "boutons" }
const _hoisted_18 = { class: "boutons-gauche" }
const _hoisted_19 = { class: "boutons-droite" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_CreationDashboardStepsBar = _resolveComponent("CreationDashboardStepsBar")!
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_check_box = _resolveComponent("check-box")!
  const _component_ButtonWhite = _resolveComponent("ButtonWhite")!
  const _component_BoutonBleu = _resolveComponent("BoutonBleu")!

  return (_ctx.enregistrementEnCours)
    ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.isOnlyForSite ? _ctx.$t('dashboard.parametrable.edition.modale.perimetre.titre') : _ctx.$t('dashboard.parametrable.modale.creation.dashboard.titre')), 1),
        (!_ctx.isOnlyForSite)
          ? (_openBlock(), _createBlock(_component_CreationDashboardStepsBar, {
              key: 0,
              step: _ctx.step
            }, null, 8, ["step"]))
          : _createCommentVNode("", true),
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "bar-horizontale" }, null, -1)),
        (_ctx.step === 1 && !_ctx.isOnlyForSite)
          ? _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 1,
              placeholder: _ctx.$t('dashboard.parametrable.modale.creation.dashboard.input.placeholder')  + ' *',
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.denominationDashboard) = $event)),
              class: "input"
            }, null, 8, _hoisted_2)), [
              [_vModelText, _ctx.denominationDashboard]
            ])
          : _createCommentVNode("", true),
        (_ctx.step === 1 && !_ctx.isOnlyForSite)
          ? (_openBlock(), _createBlock(_component_ReglePastille, {
              key: 2,
              cle: "dashboard.creationNomObligatoire"
            }))
          : (_ctx.sitesDisponibles.length !== 0 && _ctx.initialRenderComplete)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.$t('dashboard.parametrable.modale.creation.dashboard.bouton.sites.disponibles')), 1),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("img", {
                      src: _ctx.loadIconSearch,
                      class: "icon-search",
                      alt: "search"
                    }, null, 8, _hoisted_7),
                    _withDirectives(_createElementVNode("input", {
                      placeholder: _ctx.$t('dashboard.parametrable.modale.creation.dashboard.bouton.sites.recherche.placeholder'),
                      onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.filtrerSite && _ctx.filtrerSite(...args))),
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filter) = $event)),
                      class: "input-recherche-site input"
                    }, null, 40, _hoisted_8), [
                      [_vModelText, _ctx.filter]
                    ])
                  ]),
                  _cache[4] || (_cache[4] = _createElementVNode("div", { class: "demi-bar-horizontale" }, null, -1)),
                  _createVNode(_component_check_box, {
                    checked: _ctx.sitesDisponibles.length === _ctx.sitesSelectionnees.length,
                    partiel: _ctx.sitesSelectionnees.length !== 0 && _ctx.sitesDisponibles.length !== _ctx.sitesSelectionnees.length,
                    label: _ctx.$t('dashboard.parametrable.modale.creation.dashboard.bouton.sites.tous'),
                    onClick: _ctx.selectionnerTousLesSites
                  }, null, 8, ["checked", "partiel", "label", "onClick"]),
                  _createVNode(_component_ReglePastille, { cle: "dashboard.creationSitesComportement" }),
                  _cache[5] || (_cache[5] = _createElementVNode("div", { class: "demi-bar-horizontale-2" }, null, -1)),
                  _createElementVNode("div", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sitesDisponibles, (site) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: site.id
                      }, [
                        _createVNode(_component_check_box, {
                          checked: _ctx.isSiteSelectionnee(site.id),
                          label: site.description,
                          onClick: ($event: any) => (_ctx.ajouterSite(site)),
                          class: "checkbox-site"
                        }, null, 8, ["checked", "label", "onClick"])
                      ]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("h4", _hoisted_12, _toDisplayString(_ctx.$t('dashboard.parametrable.modale.creation.dashboard.perimetre.titre')), 1),
                    _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('dashboard.parametrable.modale.creation.dashboard.perimetre.description')), 1),
                    (_ctx.isOnlyForSite)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.$t('dashboard.parametrable.edition.modale.perimetre.supplement.infos')), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _cache[6] || (_cache[6] = _createElementVNode("div", { class: "demi-bar-horizontale-right" }, null, -1)),
                  _createElementVNode("div", _hoisted_15, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sitesSelectionnees, (site) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: site.id,
                        class: "pastille"
                      }, [
                        _createElementVNode("span", {
                          onClick: ($event: any) => (_ctx.ajouterSite(site)),
                          class: "cursor-pointer"
                        }, _toDisplayString(site.description) + " X", 9, _hoisted_16)
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "bar-horizontale" }, null, -1)),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_ButtonWhite, {
              "on-click": _ctx.cancel,
              text: _ctx.$t('dashboard.parametrable.modale.creation.dashboard.bouton.annuler'),
              class: "boutonAnnuler"
            }, null, 8, ["on-click", "text"]),
            (_ctx.step === 2 && !_ctx.isOnlyForSite)
              ? (_openBlock(), _createBlock(_component_ButtonWhite, {
                  key: 0,
                  "on-click": _ctx.precedent,
                  text: _ctx.$t('dashboard.parametrable.modale.creation.dashboard.bouton.precedent'),
                  class: "boutonPrecedent"
                }, null, 8, ["on-click", "text"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_19, [
            (_ctx.isOnlyForSite)
              ? (_openBlock(), _createBlock(_component_check_box, {
                  key: 0,
                  checked: _ctx.propagationWidgets,
                  label: _ctx.$t('dashboard.parametrable.edition.modale.perimetre.propagation.widgets'),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.propagationWidgets = !_ctx.propagationWidgets)),
                  class: "checkbox-site"
                }, null, 8, ["checked", "label"]))
              : _createCommentVNode("", true),
            (_ctx.isOnlyForSite)
              ? (_openBlock(), _createBlock(_component_ReglePastille, {
                  key: 1,
                  cle: "dashboard.editionPerimetrePropagationWidgets"
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_BoutonBleu, {
              "on-click": _ctx.suivant,
              text: _ctx.textBoutonSuivant,
              disabled: _ctx.isButtonDisabled,
              "with-check": _ctx.step === 2 && !_ctx.isOnlyForSite,
              class: _normalizeClass(["boutonSuivant", { boutonCreer :_ctx.step ===2, boutonEnregistrer: _ctx.isOnlyForSite} ])
            }, null, 8, ["on-click", "text", "disabled", "with-check", "class"])
          ])
        ])
      ]))
}